"use strict";
// Copyright 2020-2022 SubQuery Pte Ltd authors & contributors
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAsyncMemo = void 0;
const react_1 = require("react");
const cancellablePromise_1 = require("./cancellablePromise");
function useAsyncMemo(factory, deps, initial = undefined) {
    const [result, setResult] = (0, react_1.useState)({ data: initial, loading: false });
    const task = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        const promise = factory();
        if (promise === undefined || promise === null)
            return;
        setResult({ loading: true });
        task.current = new cancellablePromise_1.CancellablePromise(promise
            .then((data) => setResult({ data, loading: false }))
            .catch((error) => setResult({ error, loading: false })));
        return () => {
            var _a;
            (_a = task.current) === null || _a === void 0 ? void 0 : _a.cancel();
        };
    }, deps);
    const refetch = (0, react_1.useCallback)(async (retainCurrent) => {
        const promise = factory();
        if (promise === undefined || promise === null)
            return;
        setResult((current) => ({ loading: true, data: retainCurrent ? current.data : undefined }));
        task.current = new cancellablePromise_1.CancellablePromise(promise
            .then((data) => setResult({ data, loading: false }))
            .catch((error) => setResult({ error, loading: false })));
    }, [factory]);
    return Object.assign(Object.assign({}, result), { refetch });
}
exports.useAsyncMemo = useAsyncMemo;
//# sourceMappingURL=useAsyncMemo.js.map